import cn from 'classnames';
import { CheckboxProps } from './checkbox.props';
import styles from './checkbox.module.scss';

export const Checkbox = ({
  inverted,
  className,
  ...rest
}: CheckboxProps): JSX.Element => {
  const moduleStyles = cn(styles.module, className, {
    [styles.inverted]: inverted,
  });

  return <input className={moduleStyles} type="checkbox" {...rest} />;
};
